export enum Grade {
  A = "0",
  B = "1",
  C = "2",
  D = "3",
}

export const gradeTranslationsType1: Record<Grade, string> = {
  [Grade.A]: "A",
  [Grade.B]: "B",
  [Grade.C]: "C",
  [Grade.D]: "D",
};

export const gradeTranslationsType2: Record<Grade, string> = {
  [Grade.A]: "Sehr Gut",
  [Grade.B]: "Gut",
  [Grade.C]: "Kleine Lücken",
  [Grade.D]: "Lücken",
};

export const gradeTranslationsType3: Record<Grade, string> = {
  [Grade.A]: "Sehr Gut",
  [Grade.B]: "Gut",
  [Grade.C]: "Knapp genügend",
  [Grade.D]: "Ungenügend",
};

export const gradeTranslationsType4: Record<Grade, string> = {
  [Grade.A]: "Übertroffen",
  [Grade.B]: "Erfüllt",
  [Grade.C]: "Knapp erfüllt",
  [Grade.D]: "Nicht erfüllt",
};

export function getGradeOptionsType1() {
  return getGradeOptions(gradeTranslationsType1);
}

export function getGradeOptionsType2() {
  return getGradeOptions(gradeTranslationsType2);
}

function getGradeOptions(translation: Record<Grade, string>) {
  return Object.values(Grade).map((value) => ({
    value,
    label: translation[value],
  }));
}

export function calculateGrade(total: number, max: number): Grade {
  const grade = (total * 5) / max + 1;
  if (grade >= 5.3) {
    return Grade.A;
  }
  if (grade >= 4.3) {
    return Grade.B;
  }
  if (grade >= 4) {
    return Grade.C;
  }
  return Grade.D;
}
